<template>
  <div class="flex flex-col gap-7 w-full max-w-xl lg:max-w-none mx-auto">
    <SizeSelect />
    <PlanSelect v-if="store.ready" />
    <PlanSelectSkeleton v-else />
  </div>
</template>

<script setup lang="ts">
import { onMounted, onBeforeUnmount } from 'vue'
import { useBundleStore } from '@/stores'
import PlanSelect from '../bundle/plan-select.vue'
import SizeSelect from '../bundle/size-select.vue'
import PlanSelectSkeleton from '../bundle/plan-select-skeleton.vue'
import type { BundleSize, BundlePlan } from '@/types/bundle'

const store = useBundleStore()

interface BundleConfigEvent {
  size: number
  plan: string
}

const VALID_SIZES = [ 16, 24, 32 ]
const VALID_PLANS = [ 'subscription', 'onetime' ]

const handleBundleConfig = (event: Event) => {
  const { size, plan } = (event as CustomEvent<BundleConfigEvent>).detail
  if (size && VALID_SIZES.includes(size)) {
    store.setSelectedSize(size as BundleSize)
  }
  if (plan && VALID_PLANS.includes(plan)) {
    store.plan = plan as BundlePlan
  }
}

const handleAbSize = () => {
  const test = window.__ab.find((i: string) => i.startsWith('size-'))
  const size = test ? parseInt(test.replace('size-', '')) : undefined
  if (size && VALID_SIZES.includes(size)) {
    store.setSelectedSize(size as BundleSize)
  }
}

onMounted(() => {
  addEventListener('bundle.config', handleBundleConfig)
  handleAbSize()
})

onBeforeUnmount(() => {
  removeEventListener('bundle.config', handleBundleConfig)
})
</script>
